module.exports = __webpack_public_path__ + "static/media/cloudy-sun.84727814.svg";